export const _setScoresOptions = (state, action) => action.payload;
